export default [
    {
        path: '/system',
        name: '系统管理',
        redirect: '/system/api',
    },
    {
        path: '/system/api',
        name: 'api管理',
        component: resolve => require(['../components/system/Api'], resolve)
    },
    {
        path: '/system/route',
        name: '路由管理',
        component: resolve => require(['../components/system/Route'], resolve)
    },
    {
        path: '/system/role',
        name: '角色管理',
        component: resolve => require(['../components/system/Role'], resolve)
    }
]


// WEBPACK FOOTER //
// ./src/router/system.js